
$(function() {

    $('a.delete-card').click(function(event) {
        event.preventDefault();
        let deleteCardModal = $('#delete-card-modal');
        deleteCardModal.attr('data-url', $(this).attr('href'));
        console.log($(this).attr('href'));
        deleteCardModal.modal('show');
    });

    $('#delete-card-modal #submit-modal').click(function () {
        let url = $('#delete-card-modal').data('url');

        window.open(url, '_self');
        $(this).closest('#delete-card-modal').modal('hide');
    });


    $('a.add-promocode').click(function(event) {
        event.preventDefault();
        let addPromoModal = $('#add-promo-modal');
        addPromoModal.attr('data-url', $(this).attr('href'));
        addPromoModal.find('form').attr('action', event.target.href);
        let modalTitle = "Add Promo Code To " + $(this).attr('subscription_title');
        $('#add-promocode-modal-title').html(modalTitle);

        addPromoModal.modal('show');
    });

    $('#add-promo-modal #submit-modal').click(function () {
        let url = $('#add-promo-modal').data('url');

        $('#add-promo-form').submit();
        $(this).closest('#add-promo-modal').modal('hide');
    });
});
